import { ref } from 'vue'
import { defineStore } from 'pinia'

import type { Toast, ToastType } from '~/core/types'

export const useUiStore = defineStore('ui', () => {
  const backdrop = ref(false)
  const loading = ref(true)
  const timeoutId = ref()
  const timeoutTransitionId = ref()
  const screenWidth = ref(0)
  const displayMobileMenu = ref(true)
  const scroll = ref(false)

  const toast = ref<Toast>({
    displayed: false,
    content: '',
    type: '',
  })

  function hideToast(reset = true) {
    toast.value = reset
      ? { ...toast.value, content: '', displayed: false }
      : { ...toast.value, displayed: false }
  }

  function displayToast(content: string, type: ToastType, hideDelay = 3000) {
    clearTimeout(timeoutId.value)
    clearTimeout(timeoutTransitionId.value)
    toast.value = {
      displayed: true,
      content,
      type,
    }
    if (hideDelay) {
      timeoutId.value = setTimeout(() => hideToast(), hideDelay)
      timeoutTransitionId.value = setTimeout(() => hideToast(), hideDelay + 500)
    }
  }

  return {
    loading,
    scroll,
    backdrop,
    screenWidth,
    displayMobileMenu,
    toast,
    hideToast,
    displayToast,
  }
})
